<template>
    <div v-if="opened" ref="dropDown" tabindex="0" class="timepicker" @blur="closeTimePickerAway">
        <simplebar ref="scrollbar" class="with-border-track">
            <ul>
                <template v-for="(hour, keyH) in 24">
                    <template v-for="(min, keyM) in ['00', '30']">
                        <li
                            :key="`${keyH} ${keyM}`"
                            :ref="min === '30' ? 'h' + (hour - 1) + '.30' : 'h' + (hour - 1) + '.00'"
                            :class="{ active: parseInt(h) === hour - 1 && m === min }"
                            @click.prevent="setTime(hour - 1, min)"
                        >
                            {{ formatTime(hour - 1, min) }}
                        </li>
                    </template>
                </template>
            </ul>
        </simplebar>
    </div>
</template>

<script type="text/babel">
import simplebar from 'simplebar-vue';
import { formatTime } from '../helpers';
import set from 'date-fns/set';
import getMinutes from 'date-fns/getMinutes';
import getHours from 'date-fns/getHours';

export default {
    components: {
        simplebar,
    },

    props: {
        value: {
            required: true,
            validator: value => {
                return value === null || value instanceof Date || value === '';
            },
        },

        opened: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            hours: '00',
            minutes: '00',
        };
    },

    computed: {
        h: {
            get() {
                return this.hours;
            },

            set(val) {
                this.hours = val;
                this.update();
            },
        },

        m: {
            get() {
                return this.minutes;
            },

            set(val) {
                this.minutes = val;
                this.update();
            },
        },
    },

    watch: {
        $route() {
            this.closeTimePickerAway();
        },
        value(val) {
            let h = val ? getHours(val) : null;
            let m = val ? getMinutes(val) : null;
            if (h !== null && m !== null) {
                this.hours = h;
                this.minutes = m;
            }
        },
        opened(isOpened) {
            let h = this.value ? getHours(this.value) : null;
            let m = this.value ? getMinutes(this.value) : null;
            if (isOpened) {
                h = h !== null ? h : '00';
                m = m !== null ? m : '00';
                this.hours = h;
                this.minutes = m;
                this.$nextTick(() => {
                    // scroll to selected value or near
                    let min30 = parseInt(m) >= 30 ? '30' : '00';
                    let scrollbar = this.$refs.scrollbar.scrollElement;
                    scrollbar.scrollTop = this.$refs[`h${parseInt(h)}.${min30}`][0].offsetTop;
                    this.$refs.dropDown.focus();
                });
            }
        },
    },

    created() {
        if (!this.value) {
            this.h = '';
            this.m = '';
        }
    },

    methods: {
        formatTime,
        closeTimePickerAway() {
            this.hours = '00';
            this.minutes = '00';
            this.$emit('away');
        },

        update() {
            this.$emit('checkvalid');
            if (this.hours === '' && this.minutes === '') {
                this.$emit('input', '');
            } else {
                this.$emit(
                    'input',
                    set(this.value, { hours: this.hours, minutes: this.minutes, seconds: 0 })
                );
            }
        },

        setTime(h, m) {
            this.h = h < 10 ? `0${h}` : h;
            this.m = m;
            this.$emit('close');
        },
    },
};
</script>
